import $ from 'jquery';

const elements = {
    config: '.c-comments-config',
};

export default class SaveCommentsAsync {
    constructor() {
      this.updateTokens();
      $(window).ready(() => {
        this.token = $(elements.config).attr('data-post-comment-csrf-token');
        this.saveUrl = $(elements.config).attr('data-comments-api-post-comment');
        this.editUrl = $(elements.config).attr('data-comments-api-edit-comment');
      });
    }
    updateTokens() {
      this.token = $(elements.config).attr('data-comment-csrf-token');
    }
    save(item) {
        this.updateTokens();
        const postParams = {
          csrfToken: this.token,
          comment: item.message,
          parentCommentId: item.parentCommentId,
        };

        const promise = new Promise((resolve, reject) => {
          $.post(this.saveUrl, postParams)
              .done((response) => {
                  const { status, data, redirectURL } = response;

                  if (status === 'ok') {
                      return resolve(data);
                  } else if (status === 'error') {
                      return reject(data);
                  } else if (status === 'redirect') {
                      window.location.href = redirectURL;
                  }
              })
              .fail((error) => {
                return reject(error);
              });
        });

        return promise;
    }
    edit(item) {
        this.updateTokens();
        const postParams = {
          csrfToken: this.token,
          comment: item.message,
          commentId: item.id,
        };

        const promise = new Promise((resolve, reject) => {
          $.post(this.editUrl, postParams)
              .done((response) => {
                  const { status, data, redirectURL } = response;

                  if (status === 'ok') {
                      return resolve(data);
                  } else if (status === 'error') {
                      return reject(data);
                  } else if (status === 'redirect') {
                      window.location.href = redirectURL;
                  }
              })
              .fail((error) => {
                  return reject(error);
              });
        });

        return promise;
    }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/repositories/saveCommentsAsync.js